if (!window.Maximize.loadedScript.includes('province-filter.js')) {
  window.Maximize.loadedScript.push('province-filter.js');

  function provinceFilterGetTarget(card) {
    var parent = card.parentElement;
    if (!parent) return card;

    var onlyNonVisualSiblings = Array.prototype.every.call(parent.children, function (sibling) {
      return sibling === card || sibling.tagName === 'STYLE' || sibling.tagName === 'SCRIPT' || sibling.tagName === 'TEMPLATE';
    });

    return onlyNonVisualSiblings ? parent : card;
  }

  function provinceFilterSetHidden(target, hide) {
    target.classList.toggle('hidden', hide);
    if (hide) {
      target.style.setProperty('display', 'none', 'important');
    } else {
      target.style.removeProperty('display');
    }
  }

  function provinceFilterApplyCard(card) {
    var target = provinceFilterGetTarget(card);
    var show = window.Maximize.provinceFilterMatches(card.getAttribute('data-province-tag'));
    provinceFilterSetHidden(target, !show);

    if (target.closest('.swiffy-slider')) {
      if (!show && target.classList.contains('slide-item')) {
        target.dataset.wasSlideItem = 'true';
        target.classList.remove('slide-item');
      } else if (show && target.dataset.wasSlideItem) {
        target.classList.add('slide-item');
      }
    }

    if (!show && target.parentElement && target.parentElement.lastElementChild !== target) {
      target.parentElement.appendChild(target);
    }
  }

  function provinceFilterApply(root) {
    if (!root || !root.querySelectorAll) return;
    if (root.hasAttribute && root.hasAttribute('data-province-tag')) provinceFilterApplyCard(root);
    root.querySelectorAll('[data-province-tag]').forEach(provinceFilterApplyCard);
  }

  window.Maximize.applyProvinceFilter = provinceFilterApply;

  function provinceFilterHasVisibleCard(root) {
    if (!root || !root.querySelectorAll) return false;

    var found = false;
    if (root.hasAttribute && root.hasAttribute('data-province-tag') && !provinceFilterGetTarget(root).classList.contains('hidden')) {
      found = true;
    }
    root.querySelectorAll('[data-province-tag]').forEach(function (card) {
      if (!found && !provinceFilterGetTarget(card).classList.contains('hidden')) found = true;
    });
    return found;
  }

  function provinceFilterUpdateCollectionGuard(container, addedElements, force) {
    var guard = container.querySelector('[data-collection-province-guard]');
    if (!guard) return;

    if (addedElements) {
      if (guard.classList.contains('hidden')) return;

      var newlyVisible = addedElements.some(provinceFilterHasVisibleCard);
      if (!newlyVisible) return;

      guard.classList.add('hidden');
      var gridEl = container.querySelector('#ItemsGrid');
      if (gridEl) gridEl.classList.remove('hidden');
      return;
    }

    var cards = container.querySelectorAll('[data-province-tag]');
    if (!cards.length) {
      guard.classList.add('hidden');
      return;
    }

    var anyVisible = false;
    cards.forEach(function (card) {
      var target = provinceFilterGetTarget(card);
      if (!target.classList.contains('hidden')) anyVisible = true;
    });

    if (!force && !anyVisible && container.querySelector('[data-infinite-scroll-sentinel]')) return;

    guard.classList.toggle('hidden', anyVisible);
    var grid = container.querySelector('#ItemsGrid');
    if (grid) grid.classList.toggle('hidden', !anyVisible);
  }

  function provinceFilterUpdateSearchGuard(container, addedElements, force) {
    var grid = container.querySelector('#ItemsGrid-product');
    if (!grid) return;

    var guard = container.querySelector('[data-search-province-guard]');
    if (!guard) return;

    if (addedElements) {
      if (guard.classList.contains('hidden')) return;

      var newlyVisible = addedElements.some(provinceFilterHasVisibleCard);
      if (!newlyVisible) return;

      guard.classList.add('hidden');
      grid.classList.remove('hidden');
      return;
    }

    var cards = grid.querySelectorAll('[data-province-tag]');
    if (!cards.length) {
      guard.classList.add('hidden');
      return;
    }

    var anyVisible = false;
    cards.forEach(function (card) {
      var target = provinceFilterGetTarget(card);
      if (!target.classList.contains('hidden')) anyVisible = true;
    });

    if (!force && !anyVisible && container.querySelector('[data-infinite-scroll-sentinel]')) return;

    guard.classList.toggle('hidden', anyVisible);
    grid.classList.toggle('hidden', !anyVisible);
  }

  function provinceFilterUpdateGuardedSections(root) {
    root = root || document;
    root.querySelectorAll('[data-province-guarded-section]').forEach(function (section) {
      var cards = Array.prototype.filter.call(section.querySelectorAll('[data-province-tag]'), function (card) {
        return !card.closest('.product-card__wrapper');
      });
      if (!cards.length) return;

      var anyVisible = false;
      cards.forEach(function (card) {
        var target = provinceFilterGetTarget(card);
        if (!target.classList.contains('hidden')) anyVisible = true;
      });

      section.classList.toggle('hidden', !anyVisible);
    });
  }

  function provinceFilterUpdateCollectionTabGuard(root) {
    root = root || document;
    root.querySelectorAll('[data-collection-tab-guard]').forEach(function (guard) {
      var scope = guard.parentElement;
      if (!scope) return;
      guard.classList.toggle('hidden', provinceFilterHasVisibleCard(scope));
    });
  }

  window.Maximize.updateCollectionTabGuard = provinceFilterUpdateCollectionTabGuard;

  function provinceFilterUpdateSliderNav(root) {
    root = root || document;
    root.querySelectorAll('.swiffy-slider').forEach(function (slider) {
      if (!slider.querySelector('[data-province-tag]')) return;

      var container = slider.querySelector('.slider-container');
      var navWrapper = slider.querySelector('.slider-nav-wrapper');
      if (!container || !navWrapper) return;

      var hasOverflow = container.scrollWidth > container.clientWidth + 1;
      navWrapper.classList.toggle('hidden', !hasOverflow);
    });
  }

  var PROVINCE_FILTER_OBSERVED_SELECTORS = [
    '#ProductGridContainer',
    '.product-recommendations',
    '#predictive-search-results'
  ];

  function provinceFilterObserve(el) {
    if (!el || el.dataset.provinceFilterObserved) return;
    el.dataset.provinceFilterObserved = 'true';

    var isCollectionGrid = el.id === 'ProductGridContainer';
    var observerConfig = { childList: true, subtree: true };
    var observer;
    var run = function (mutationsList) {
      if (observer) observer.disconnect();

      var addedElements = null;
      if (mutationsList) {
        addedElements = [];
        mutationsList.forEach(function (mutation) {
          mutation.addedNodes.forEach(function (node) {
            if (node.nodeType === 1) {
              provinceFilterApply(node);
              addedElements.push(node);
            }
          });
        });
      } else {
        provinceFilterApply(el);
      }

      if (isCollectionGrid) {
        provinceFilterUpdateCollectionGuard(el, addedElements);
        provinceFilterUpdateSearchGuard(el, addedElements);
      }
      if (observer) observer.observe(el, observerConfig);
    };

    run();
    observer = new MutationObserver(run);
    observer.observe(el, observerConfig);
  }

  window.Maximize.provinceFilterObserve = provinceFilterObserve;

  function provinceFilterObserveAll() {
    provinceFilterApply(document);
    provinceFilterUpdateGuardedSections(document);
    provinceFilterUpdateCollectionTabGuard(document);
    provinceFilterUpdateSliderNav(document);

    PROVINCE_FILTER_OBSERVED_SELECTORS.forEach(function (selector) {
      document.querySelectorAll(selector).forEach(provinceFilterObserve);
    });
    document.querySelectorAll('[id^="x-recently-viewed-"]').forEach(provinceFilterObserve);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', provinceFilterObserveAll);
  } else {
    provinceFilterObserveAll();
  }

  document.addEventListener('province-selection-changed', function () {
    provinceFilterApply(document);
    provinceFilterUpdateGuardedSections(document);
    provinceFilterUpdateCollectionTabGuard(document);
    provinceFilterUpdateSliderNav(document);
    var collectionGrid = document.getElementById('ProductGridContainer');
    if (collectionGrid) {
      provinceFilterUpdateCollectionGuard(collectionGrid);
      provinceFilterUpdateSearchGuard(collectionGrid);
    }
  });

  document.addEventListener('maximize:product-recommendations:change:', function () {
    provinceFilterApply(document);
  });

  document.addEventListener('maximize:pagination:auto-load-capped', function () {
    var collectionGrid = document.getElementById('ProductGridContainer');
    if (collectionGrid) provinceFilterUpdateCollectionGuard(collectionGrid, null, true);
  });

  document.addEventListener('maximize:pagination-search:auto-load-capped', function () {
    var searchGrid = document.getElementById('ProductGridContainer');
    if (searchGrid) provinceFilterUpdateSearchGuard(searchGrid, null, true);
  });

  var registerProvinceGuard = function () {
    Alpine.data('xProvinceGuard', () => ({
      showContent: true,
      init() {
        this.evaluate();
        document.addEventListener('province-selection-changed', () => this.evaluate());
      },
      evaluate() {
        this.showContent = window.Maximize.provinceFilterMatches(this.$el.getAttribute('data-product-province-tag'));
      }
    }));
  };
  if (window.Alpine) {
    registerProvinceGuard();
  } else {
    document.addEventListener('alpine:init', registerProvinceGuard);
  }

  // Customize by developer Omnithemes / Bay Vape - province menu lazy loading.
  // Province override menus are no longer rendered into every page. The header only renders the
  // default menus plus empty x-html slots; this store fetches the active province's menus once
  // (Section Rendering API, see sections/header.liquid "fragment mode"), caches them for the tab
  // session and hands them to the slots.
  var registerProvinceMenu = function () {
    Alpine.store('xProvinceMenu', {
      activeTaxTag: (window.Maximize.getProvinceSelection() || {}).taxTag || '',
      fragments: {},
      status: 'idle', // idle | loading | ready | failed
      _config: null,
      init() {
        document.addEventListener('province-selection-changed', (event) => {
          this.activeTaxTag = event.detail.taxTag || '';
          this.fragments = {};
          this.status = 'idle';
          if (this.usesOverride()) this.load();
        });

        // Warm the menus after the page has loaded so they're ready before the first hover/tap.
        var warm = () => {
          var idle = window.requestIdleCallback || function (cb) { return setTimeout(cb, 1500); };
          idle(() => { if (this.usesOverride()) this.load(); }, { timeout: 4000 });
        };
        if (document.readyState === 'complete') warm();
        else window.addEventListener('load', warm, { once: true });
      },
      config() {
        if (!this._config) {
          var el = document.getElementById('bv-province-menu-config');
          try {
            this._config = el ? JSON.parse(el.textContent) : {};
          } catch (e) {
            this._config = {};
          }
        }
        return this._config;
      },
      // True when the active province has an override menu (for the given block's tags, or any block).
      // Returns false after a failed fetch so the default menus show instead of an empty panel.
      usesOverride(tags) {
        if (this.status === 'failed' || !this.activeTaxTag) return false;
        var list = tags || this.config().tags || [];
        return list.indexOf(this.activeTaxTag) !== -1;
      },
      fragment(key, tags) {
        if (!this.usesOverride(tags)) return '';
        if (this.status === 'idle') queueMicrotask(() => this.load());
        return this.fragments[key] || '';
      },
      load() {
        var tag = this.activeTaxTag;
        var cfg = this.config();
        if (!tag || !cfg.sectionId || this.status === 'loading' || this.status === 'ready') return;

        var cacheKey = 'bv-province-menu:' + cfg.version + ':' + cfg.sectionId + ':' + tag;
        var useCache = !(window.Shopify && window.Shopify.designMode); // always fresh in the theme editor
        try {
          var cached = useCache && sessionStorage.getItem(cacheKey);
          if (cached) {
            this.fragments = JSON.parse(cached);
            this.status = 'ready';
            return;
          }
        } catch (e) {}

        this.status = 'loading';
        var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        var url = root + 'search?type=page&options%5Bprefix%5D=none&q=' + encodeURIComponent('bvmenu--' + tag) + '&section_id=' + encodeURIComponent(cfg.sectionId);
        // Unpublished/preview themes: background requests must name the theme or Shopify renders the live one.
        if (window.Shopify && window.Shopify.theme && window.Shopify.theme.role !== 'main' && window.Shopify.theme.id) {
          url += '&preview_theme_id=' + window.Shopify.theme.id;
        }

        fetch(url, { credentials: 'same-origin' })
          .then((response) => {
            if (!response.ok) throw new Error('HTTP ' + response.status);
            return response.text();
          })
          .then((html) => {
            if (tag !== this.activeTaxTag) return; // province changed while loading; the new load handles it
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var map = {};
            doc.querySelectorAll('template[data-bv-fragment]').forEach((tpl) => {
              map[tpl.getAttribute('data-bv-fragment')] = tpl.innerHTML;
            });
            if (!Object.keys(map).length) throw new Error('no menu fragments in response');
            this.fragments = map;
            this.status = 'ready';
            try {
              if (useCache) sessionStorage.setItem(cacheKey, JSON.stringify(map));
            } catch (e) {}
          })
          .catch((error) => {
            console.warn('[province-menu] falling back to default menus:', error);
            if (tag === this.activeTaxTag) this.status = 'failed';
          });
      }
    });
  };
  if (window.Alpine) {
    registerProvinceMenu();
  } else {
    document.addEventListener('alpine:init', registerProvinceMenu);
  }
}
